import React from 'react'
import ReactDOM from 'react-dom/client'

import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  BarController,
  Legend, ArcElement, Filler, BarElement,
} from 'chart.js'

import MapBoxGL from 'mapbox-gl'
import { MapProvider } from 'react-map-gl'
import './resources/mapbox.css'

import 'moment/locale/ru'
import 'moment/locale/uz'
import 'moment/locale/uz-latn'

import { IQContextProvider } from '@iqueue/ui-kit'
import '@iqueue/ui-kit/lib/ui-kit.css'
import '@iqueue/ui-kit/lib/icons.css'
import '@iqueue/ui-kit/lib/roboto.css'
import './resources/index.scss'

import App from './App'

import { debugPrintLocaleSources, debugPrintLocalesDiff, appendLocaleSources } from './hooks/useTranslate'

MapBoxGL.accessToken = process.env.REACT_APP_MAP_BOX_ACCESS_TOKEN

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement, Filler, BarElement, BarController)

setTimeout(() => {
  debugPrintLocaleSources('ru')
  debugPrintLocalesDiff('en', 'ru')
}, 1000)

const root = ReactDOM.createRoot(document.getElementById('root'))
// root.render(<React.StrictMode>
//   <IQContextProvider>
//     <MapProvider>
//       <App/>
//     </MapProvider>
//   </IQContextProvider>
// </React.StrictMode>)

root.render(<IQContextProvider listItems={ {} }>
  <MapProvider>
    <App/>
  </MapProvider>
</IQContextProvider>)
